import React from 'react'

import clsx from 'clsx'

import { Button } from '@insquad/tools'
import Image from 'next/image'

import {
  EnumTypographyVariants,
  Typography,
} from 'src/common/components/Typography/Typography'
import { useAuthRedirect } from 'src/common/hooks/useAuthRedirect'

import bannerImg from './bannerImg.png'

import s from './AsideContentBanner.module.scss'

export type AsideContentBannerProps = {
  className?: string
}

export const AsideContentBanner: React.FC<AsideContentBannerProps> = ({
  className,
}) => {
  const { handleSignUpRedirect } = useAuthRedirect()

  return (
    <div className={clsx(s.AsideContentBanner, className)}>
      <div className={s.AsideContentBanner__img}>
        <Image
          src={bannerImg.src}
          layout="fill"
          objectFit="contain"
          unoptimized
          alt=""
        />
      </div>

      <Typography
        variant={EnumTypographyVariants.H5}
        as="p"
        text="Scale your team 4x faster with remote Insquad Startup developers"
        className={s.AsideContentBanner__description}
      />

      <Button
        onClick={() => handleSignUpRedirect()}
        className={s.AsideContentBanner__btn}
      >
        Sign Up
      </Button>
    </div>
  )
}
